<ng-template #selectLabel>
    <ng-content></ng-content>
</ng-template>

<ng-template #selectSupportingText>
    <ng-content select="[selectSupportingText]"></ng-content>
</ng-template>